var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGetResumeScore = function SvgGetResumeScore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#getResumeScore_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3A3A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.833 18.83h.228c2.717 0 4.076 0 5.02-.664q.404-.285.712-.671c.707-.888.707-2.167.707-4.725v-2.12c0-2.47 0-3.705-.39-4.69-.63-1.587-1.957-2.837-3.642-3.428-1.047-.368-2.358-.368-4.983-.368-1.498 0-2.248 0-2.847.21-.962.338-1.721 1.053-2.08 1.958-.225.564-.225 1.27-.225 2.68v4.319"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3A3A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.5 10.497a2.777 2.777 0 0 0-2.777-2.777c-.556 0-1.21.097-1.749-.048a1.39 1.39 0 0 1-.982-.983c-.145-.54-.048-1.193-.048-1.748a2.78 2.78 0 0 0-2.777-2.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3A3A",
    d: "M4.995 18.467a1.254 1.254 0 0 0 .625-2.337l-3.535-2.047c-.14-.08-.297.076-.216.216l2.01 3.48c.207.408.628.688 1.116.688m0-5.417c-.695 0-1.347.176-1.924.471a.092.092 0 0 0-.002.162l.73.421a3.332 3.332 0 0 1 3.554 5.467H7.35a.416.416 0 0 0 0 .587c.162.163.43.163.592.004a4.15 4.15 0 0 0 1.22-2.945 4.18 4.18 0 0 0-4.166-4.167M.828 17.216c0 1.15.467 2.192 1.221 2.946a.419.419 0 0 0 .71-.298.42.42 0 0 0-.123-.293 3.31 3.31 0 0 1-.975-2.355c0-.416.08-.833.225-1.208l-.42-.73a.092.092 0 0 0-.162.003 4.24 4.24 0 0 0-.476 1.935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "getResumeScore_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 .5H0v20h20z"
  })))));
};
export default SvgGetResumeScore;